import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/master/surveys'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        createResponseSurveyBySurveyId(context, { data, config }) {
            return base.request.post(`${baseUrl}/create-response-survey-by-survey-id`, data, { ...config })
        },
        generateQRCode(context, { data, config }) {
            return base.request.post(`${baseUrl}/generate-qr-code`, data, { ...config })
        },
        reports(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/survey`, data, { ...config, responseType: "blob" });
        },
        getSurveyResponseLink(context, { id, config }) {
            return base.request.get(`${baseUrl}/survey-response-link/${id}`, { ...config });
        },
    },
    mutations: {
        ...base.mutations
    },
}
